import { MutationTuple, useMutation } from '@apollo/client';
import { ApproveMilestonePayload, MilestoneStatusInput } from '@bechtel/types';
import { APPROVE_MILESTONE } from '@bechtel/client-gql';

export function useApproveMilestone(
  onActionCompleted?: () => void
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ approveMilestone: ApproveMilestonePayload }, { input: MilestoneStatusInput }> {
  const response = useMutation<{ approveMilestone: ApproveMilestonePayload }, { input: MilestoneStatusInput }>(
    APPROVE_MILESTONE,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: () => {
        if (onActionCompleted) onActionCompleted();
      },
      onError: () => {
        if (onActionCompleted) onActionCompleted();
      },
    }
  );
  return response;
}
